import { gql } from '@apollo/client';
import { Box, Tooltip } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { CellProps } from 'react-table';
import { Maybe } from '~graphql/__generated__/types';
import { DisplayTable_DisplayFragment } from '../__generated__/DisplayTableServerSide.graphql';
import { ScheduleCell_ValueFragment } from './__generated__/ScheduleCell.graphql';

/**
 * Counterpart of `PowerScheduleCell`: the display's `schedule` title instead of
 * its power schedule.
 */
export function ScheduleCell({
  value,
}: PropsWithChildren<
  CellProps<DisplayTable_DisplayFragment, Maybe<ScheduleCell_ValueFragment> | undefined>
>) {
  if (value?.schedule == null) {
    return <Box />;
  }

  return (
    <Tooltip label={value.schedule?.title}>
      <Box overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
        {value.schedule?.title}
      </Box>
    </Tooltip>
  );
}

ScheduleCell.graphql = {
  fragments: {
    ScheduleCell_value: gql`
      fragment ScheduleCell_value on DisplaySchedule {
        schedule {
          title
        }
      }
    `,
    ScheduleCell_display: gql`
      fragment ScheduleCell_display on Display {
        id
        schedule {
          ...ScheduleCell_value
        }
      }
    `,
  },
};
